import { CommonGet, CommonPost } from "../../../utils/CommonFetch";
import tokenDecoder from "../../Common/tokenDecoder";

export default {
    getAllDivisionsByEstateID,
    getOperationEntityByType,
    getCollectionPointCategoryIDByEstateID,
    getGroupsForDropdown,
    GetAllEstatesByGroupID,
    getCollectionPointByID,
    getCSVData,
    getEstatesByGroupID
};

async function getAllDivisionsByEstateID(estateID) {
    var divisionArray = [];

    const response = await CommonGet('/api/CollectionPoint/GetAllRoutesByFactoryID', 'factoryID=' + estateID);
    for (let item of Object.entries(response.data)) {
        divisionArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]

    }
    return divisionArray;
}

async function getOperationEntityByType(groupID) {
    const dataArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', 'groupID=' + groupID);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true)
            dataArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return dataArray;
}

async function getEstatesByGroupID(groupID) {
    const response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', 'groupId=' + groupID);
    let array = []
    for (let item of Object.entries(response.data)) {

        array[item[1]["operationEntityID"]] = item[1]["operationEntityName"]

    }
    return array;
}

async function getCollectionPointByID(id) {
    const response = await CommonGet('/api/CollectionPoint/GetCollectionPointById', 'id=' + id);
    return response.data;
}

async function getCollectionPointCategoryIDByEstateID(estateID) {
    var collectionPointCategoryArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetCollectionPointCategoryIDByEstateID', 'estateID=' + estateID);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            collectionPointCategoryArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return collectionPointCategoryArray;
}

async function getGroupsForDropdown() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function GetAllEstatesByGroupID(groupID) {
    var estateArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllFactoriesByGroupID', 'groupID=' + groupID)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return estateArray;

}

async function getCSVData(data) {
    var filterModel = {
        groupID: data.groupID,
        operationEntityID: data.estateID,
        collectionPointID: data.collectionPointCategoryID,
        searchDate: data.searchDate
    }
    const response = await CommonPost('/api/CSVFileDownload/GetCSVData', null, filterModel);
    return response.data;
}



